// removed by extract-text-webpack-plugin
module.exports = {"intakeCheckboxLabel":"CheckboxFilterPanel__intakeCheckboxLabel___189U-","blockCheckbox":"CheckboxFilterPanel__blockCheckbox___1lSne"};